import * as React from 'react';
const SvgCaret = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, fill: "none" }, props),
    React.createElement("rect", { width: 32, height: 32, fill: "#F0F0F0", rx: 5 }),
    React.createElement("path", { fill: "#BDBDBD", d: "m15.273 23.273 6.928-12H8.344l6.929 12Z" })));
export default SvgCaret;
